<template>
  <v-row align="center" justify="center">
    Page Not Found
  </v-row>
</template>

<script>
export default {
  name: 'pageNotFound'
}
</script>
